{
  "version": 1,
  "asset_id": "0721c01b-da90-42c4-a4d2-43810f7f2aca",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0721c01b-da90-42c4-a4d2-43810f7f2aca/hero-abstract-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0721c01b-da90-42c4-a4d2-43810f7f2aca/hero-abstract-1280.webp",
  "original_filename": "hero-abstract-1280.webp",
  "size": 44738,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:55Z"
}
